import { get, isEmpty } from 'lodash';
var deserializeMeta = function deserializeMeta(response) {
  var meta = {};
  var page = get(response, 'data.meta.page');
  if (!isEmpty(page)) {
    var hasNextPage = get(page, 'has_next_page');
    if (hasNextPage !== undefined) {
      meta.paging = {
        current_page: page.number,
        next_page: hasNextPage ? parseInt(page.number, 10) + 1 : null,
        prev_page: parseInt(page.number, 10) === 1 ? null : parseInt(page.number, 10) - 1,
        per: page.size,
        page_length: get(response, 'data.data', []).length
      };
    } else {
      meta.paging = {
        current_page: page.number,
        next_page: parseInt(page.number, 10) >= parseInt(page.total_pages, 10) ? null : parseInt(page.number, 10) + 1,
        prev_page: parseInt(page.number, 10) === 1 ? null : parseInt(page.number, 10) - 1,
        per: page.size,
        total_count: page.total_count,
        total_pages: page.total_pages
      };
    }
  }
  return meta;
};
export default function buildJSONAPIDeserializerInterceptor(serializer) {
  return function (response) {
    try {
      if (!response.data || response.status === 204) {
        return {
          response: response
        };
      }
      if (new RegExp('/users/accept_eula').test(response.config.url)) {
        // TEMPORARY! made a backend ticket for this - https://uniteus.atlassian.net/browse/CORE-862
        return response;
      }
      var serialized = serializer.deserialize({
        type: function type(data) {
          return data.type;
        }
      }, response.data);
      var meta = deserializeMeta(response);
      response.data.paging = meta.paging;
      response.data.data = serialized;
      return {
        response: response,
        serialized: serialized,
        meta: meta
      };
    } catch (error) {
      console.error('buildJSONAPIDeserializerInterceptor error', error);
    }
  };
}
//# sourceMappingURL=buildJSONAPIDeserializerInterceptor.js.map